import { CaseStatus } from '@/static/enums/caseStatus';

/**
 * Map of case statuses and whether the case is editable
 * in that given status.
 *
 * While the case is not editable then we also assume that we should
 * request the case from api again, in order to check whether
 * its status has changed.
 */
export const caseStatusesEditable: Record<CaseStatus, boolean> = {
  [CaseStatus.ARCHIVED]: true,
  [CaseStatus.CLOSED]: true,
  [CaseStatus.OPEN]: true,
  [CaseStatus.PARTIALLY_CLOSED]: true,
  [CaseStatus.REJECTED]: true,
  [CaseStatus.STOPPED]: true,
  [CaseStatus.TARN]: true,
  [CaseStatus.BEING_CLOSED]: false,
  [CaseStatus.BEING_PARTIALLY_CLOSED]: false,
  [CaseStatus.BEING_STOPPED]: false,
  [CaseStatus.BEING_UNSTOPPED]: false,
  [CaseStatus.BEING_REOPENED]: false,
};
